import { defineComponent, onMounted, onUnmounted } from 'vue'
import KJsonParse from '../../../json-parse/index'
import UEI from '../use/useEditInfo'
import { dragIntoContainer } from '../utils/dragEvent'
import { mouseMethods } from '../utils/mouseEvent'
import { keyboardMethods } from "../utils/keyboardEvent";
import { ScaleRect } from '../component/scale-rect'
import { HelpLine } from '../component/help-line'
export default defineComponent({
  name: 'JsonCanves',
  components: { ScaleRect, HelpLine },
  setup() {
    // 页面加载完成监听事件--------------------------------------------------------------------------
    let containerBox: HTMLElement | undefined
    let rootBox: HTMLElement | undefined
    onMounted(() => {
      containerBox = document.getElementById('comp-canves-wrap') || undefined
      // rootBox = document.querySelector('[isroot=true]') as HTMLElement
      rootBox = document.getElementById('comp-canves-wrap-child') as HTMLElement
      if (!rootBox) return
      rootBox.addEventListener('dragover', dragIntoContainer.dragOver)
      rootBox.addEventListener('dragleave', dragIntoContainer.dragLeave)
      rootBox.addEventListener('dragenter', dragIntoContainer.dragEnter)
      rootBox.addEventListener('drop', dragIntoContainer.dragDrop)
      if (!containerBox) return
      containerBox.addEventListener('mousedown', mouseMethods.mouseDown)
      containerBox.addEventListener('mousemove', mouseMethods.mouseMove)
      containerBox.addEventListener('mouseup', mouseMethods.mouseUp)
      containerBox.addEventListener('click', mouseMethods.dragedClick)
      // 监听键盘事件
      document.addEventListener('keydown', keyboardMethods.keyDown)
      // document.addEventListener('keyup', keyboardMethods.keyUp)
    })
    onUnmounted(() => {
      // 解除键盘事件
      document.removeEventListener('keydown', keyboardMethods.keyDown)
      // document.removeEventListener('keyup', keyboardMethods.keyUp)
      clearTimeout(dragIntoContainer.timer)
      // 解除其它事件
      if (!rootBox) return
      rootBox.removeEventListener('dragover', dragIntoContainer.dragOver)
      rootBox.removeEventListener('dragleave', dragIntoContainer.dragLeave)
      rootBox.removeEventListener('dragenter', dragIntoContainer.dragEnter)
      rootBox.removeEventListener('drop', dragIntoContainer.dragDrop)
      if (!containerBox) return
      containerBox.removeEventListener('mousedown', mouseMethods.mouseDown)
      containerBox.removeEventListener('mousemove', mouseMethods.mouseMove)
      containerBox.removeEventListener('mouseup', mouseMethods.mouseUp)
      containerBox.removeEventListener('click', mouseMethods.dragedClick)
    })

    return () => {
      return (
        <div class="comp-canves-wrap-child" id="comp-canves-wrap-child" style="width:100%;padding:20px;" {...{ onContextmenu: (e: MouseEvent) => mouseMethods.onContextmenuBlock(e) }}>
          <KJsonParse layout={UEI.state.globalLayout} mock={UEI.state.mockData} editor={true} />
          <scale-rect />
          <help-line />
        </div>
      )
    }
  }
})
